import { SpeciesEnum } from "../../../../../__generated__/globalTypes";
import { Package, PackageFeature, PackageIcon } from "./types";

export enum limitsEnum {
  OP = 0,
  Mini = 300000,
  Midi = 100000,
  Maxi = 9999999900,
}

// TODO: Consolidate
export const plans = ({
  species,
  name,
  birthday,
  breed,
  sex,
  access,
  copay,
}: {
  species: SpeciesEnum | null;
  name: string;
  birthday: string;
  breed: string;
  sex: string;
  access: string;
  copay: number;
}) => [
  {
    // OP
    limit: limitsEnum.OP,
    deductible: 0,
    ratingsData: {
      copay,
      name,
      birthday,
      breed,
      sex,
      ...(species === SpeciesEnum.cat ? { access: access } : {}),
    },
  },
  {
    // Healthcare small
    limit: limitsEnum.Mini,
    deductible: 0,
    ratingsData: {
      copay,
      name,
      birthday,
      breed,
      sex,
      ...(species === SpeciesEnum.cat ? { access: access } : {}),
    },
  },
  {
    // Healthcare medium
    limit: limitsEnum.Midi,
    deductible: 0,
    ratingsData: {
      copay,
      name,
      birthday,
      breed,
      sex,
      ...(species === SpeciesEnum.cat ? { access: access } : {}),
    },
  },
  {
    // Healthcare large
    limit: limitsEnum.Maxi,
    deductible: 0,
    ratingsData: {
      copay,
      name,
      birthday,
      breed,
      sex,
      ...(species === SpeciesEnum.cat ? { access: access } : {}),
    },
  },
];

const opFeatures: PackageFeature[] = [];

const miniFeatures: PackageFeature[] = [
  {
    title: "Behandlungskosten: 3.000 € pro Jahr",
  },
  {
    title: "Vorsorgepauschale: 35 € pro Jahr",
  },
];

const midiFeatures: PackageFeature[] = [
  {
    title: "Behandlungskosten:",
    additional: [
      "1. Jahr: 1.000 €",
      "2. Jahr: 2.000 €",
      "Ab dem 3. Jahr: Unbegrenzt",
    ],
  },
  {
    title: "Vorsorgepauschale: 100 € pro Jahr",
  },
];

const maxiFeatures: PackageFeature[] = [
  {
    title: "Behandlungskosten: Unbegrenzt",
  },
  {
    title: "Vorsorgepauschale: 140 € pro Jahr",
  },
  {
    title: "Verhaltenstherapie",
  },
  {
    title:
      "Spezialdiagnostik (z.B. MRT/CT): Immer, bei medizinischer Notwendigkeit",
  },
  {
    title: "Vorsorge Kastration/Sterilisation",
  },
];

export const sharedFeatures: PackageFeature[] = [
  {
    title: "Unbegrenzte Operationskosten",
  },
  {
    title: "24/7 Tierarztsprechstunde per Video.",
    additional: ["(For OP: 10 Tage vor & 30 Tage nach Operationen)"],
  },
  {
    title: "Spezialdiagnostik (z.b. MRT/CT): Bei Operationen",
  },
  {
    title: "Ultraschall, Röntgen",
  },
  {
    title: "Tierarztgebühren bis 4-facher GOT Satz",
  },
  {
    title: "Freie Tierarzt- und Klinikwahl",
  },
  {
    title: "Arzneimittel, Medikamente",
  },
  {
    title: "12 Monate Auslandsschutz",
  },
];

export const getPackages: (
  species: SpeciesEnum | null
) => Package<limitsEnum>[] = (species) =>
  [
    {
      name: "Maxi",
      icon: "steak" as PackageIcon,
      limit: limitsEnum.Maxi,
      species: SpeciesEnum.cat,
      headline: "ALLE BASISLEISTUNGEN ENTHALTEN SOWIE:",
      features: maxiFeatures,
    },
    {
      default: true,
      name: "Midi",
      icon: "sausages" as PackageIcon,
      limit: limitsEnum.Midi,
      species: SpeciesEnum.cat,
      headline: "ALLE BASISLEISTUNGEN ENTHALTEN SOWIE:",
      features: midiFeatures,
    },
    {
      name: "Mini",
      icon: "meatbone" as PackageIcon,
      limit: limitsEnum.Mini,
      species: SpeciesEnum.cat,
      headline: "ALLE BASISLEISTUNGEN ENTHALTEN SOWIE:",
      features: miniFeatures,
    },
    {
      name: "OP",
      icon: "bone" as PackageIcon,
      limit: limitsEnum.OP,
      species: SpeciesEnum.cat,
      headline: "ALLE BASISLEISTUNGEN ENTHALTEN",
      tagline: "Versicherungsschutz für Operationen",
      features: opFeatures,
    },
    {
      name: "Maxi",
      icon: "steak" as PackageIcon,
      limit: limitsEnum.Maxi,
      species: SpeciesEnum.dog,
      headline: "ALLE BASISLEISTUNGEN ENTHALTEN SOWIE:",
      features: maxiFeatures,
    },
    {
      default: true,
      name: "Midi",
      icon: "sausages" as PackageIcon,
      limit: limitsEnum.Midi,
      species: SpeciesEnum.dog,
      headline: "ALLE BASISLEISTUNGEN ENTHALTEN SOWIE:",
      features: midiFeatures,
    },
    {
      name: "Mini",
      icon: "meatbone" as PackageIcon,
      limit: limitsEnum.Mini,
      species: SpeciesEnum.dog,
      headline: "ALLE BASISLEISTUNGEN ENTHALTEN SOWIE:",
      features: miniFeatures,
    },
    {
      name: "OP",
      icon: "bone" as PackageIcon,
      limit: limitsEnum.OP,
      species: SpeciesEnum.dog,
      headline: "ALLE BASISLEISTUNGEN ENTHALTEN",
      tagline: "Versicherungsschutz für Operationen",
      features: opFeatures,
    },
  ].filter((pack) => pack.species === species);
